/* eslint-disable max-params */

import * as busyCounter from '../../../shared/action-creators/busy-counter';
import actions from '../../actions-list';
import {getFileName} from '../../../shared/services/get-file-name';
import {getRgaCollection} from '../../shared/repositories';
import {openFile} from '../../../shared/services/open-file';
import {routerActions} from 'react-router-redux';

const buildTrimmedRgaFilterCriteria = rgaFilterCriteria => {

    const trimmedCriteria = {};

    Object.keys(rgaFilterCriteria).forEach(key => {

        if (typeof rgaFilterCriteria[key] === 'string') {

            trimmedCriteria[key] = rgaFilterCriteria[key].trim();

        } else if (Array.isArray(rgaFilterCriteria[key])) {

            trimmedCriteria[key] = rgaFilterCriteria[key].map(value =>
                typeof value === 'string' ? value.trim() : value
            );
            if (trimmedCriteria[key].length === 1 && trimmedCriteria[key][0] === '') {

                trimmedCriteria[key] = [];

            }

        } else {

            trimmedCriteria[key] = rgaFilterCriteria[key];

        }

    });
    return trimmedCriteria;

};

export const getRgaCollections = (rgaFilterCriteria, isExport, isInitialLoad, pageno) =>

    async dispatch => {

        dispatch(busyCounter.increaseBusyCounter());

        try {

            const trimmedRgaFilterCriteria = buildTrimmedRgaFilterCriteria(rgaFilterCriteria);
            const rgaCollection = await getRgaCollection(trimmedRgaFilterCriteria, isExport, pageno);

            if (isExport === 'EXCEL') {

                const fileName = getFileName(rgaCollection);

                const blob = await rgaCollection.blob();

                openFile(blob, fileName, 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');

            } else {

                dispatch({
                    isInitialLoad,
                    rgaCollection,
                    type: actions.UPDATE_RGA_SEARCH_RESULTS
                });

            }

            if (rgaCollection.length < 100) {

                dispatch({
                    isEmptyRgaSearchResult: true,
                    type: actions.UPDATE_RGA_SEARCH_RESULTS_FLAG
                });

            } else {

                dispatch({
                    isEmptyRgaSearchResult: false,
                    type: actions.UPDATE_RGA_SEARCH_RESULTS_FLAG
                });

            }

        } catch (error) {

            dispatch({
                rgaCollection: [],
                type: actions.UPDATE_RGA_SEARCH_RESULTS
            });

            dispatch(routerActions.push('/rga'));

        } finally {

            dispatch(busyCounter.decreaseBusyCounter());

        }

    };



// WEBPACK FOOTER //
// ./src/rga/rga-search-results/action-creators/rga-list.js